import './styles.scss';

/**
 * Item component renders a single highlight entry with a title and description.
 * Used inside the GameHighlights list.
 *
 * @param {string} title — Highlight heading text.
 * @param {string} description — Highlight body text shown under the title.
 */

export const Item = ({ title, description }) => (
    <div className='game-highlights-item'>
        <h3 className='game-highlights-item__title'>{title}</h3>

        <p className='game-highlights-item__description'>{description}</p>
    </div>
);
